<template>
  <PageHeaderTitleContent>
    <TitleTextContent
      :titleText="pageTitle"
      :subTitleText="subText"
      :subTitleTextMdLgXlWidth="desktopSubTitleWidth"
      :subTitleTextSmXsWidth="mobileSubTitleWidth"
    />
    <router-link
      :to="{
        name: route
      }"
    >
      <v-btn
        rounded
        large
        dark
        :color="'#424EC4'"
        class="my-4 mb-lg-0 mb-xl-0"
      >{{ backButtonText }}</v-btn>
    </router-link>
  </PageHeaderTitleContent>
</template>

<script>
  import PageHeaderTitleContent from "./page-header-title-content.vue";
  import TitleTextContent from "./title-text-content.vue";

  export default {
    components: {
      PageHeaderTitleContent,
      TitleTextContent,
    },
    props: {
      pageTitle: String,
      route: String,
      subText: {
        type: String,
        default: null,
      },
      desktopSubTitleWidth: {
        type: String,
        default: '50%',
      },
      mobileSubTitleWidth: {
        type: String,
        default: '50%',
      },
      backButtonText: String,
    },
  }
</script>